import './index.scss';
import React, {useEffect, useState} from 'react';
import {withRouter} from "react-router-dom";
import {useForm} from "react-hook-form"
import ButtonSubmit from '../../../ButtonSubmit';
import {Redirect} from 'react-router-dom';
import axios from 'axios'
import InputText from "../../_components/InputText";
import InputDate from "../../_components/InputDate";
import InputSelect from "../../_components/InputSelect";
import {encodeJson} from '../../_api';
import './index.scss';

const PayoffRequest = props => {

    const [submitted, setSubmitted] = useState(false);
    const [success, setSuccess] = useState(null); // state for API submission
    const {register, handleSubmit, errors, watch} = useForm();
    const watchSellOrFinance = watch("sale_or_refinance");

    const inputCurrency = e => {
        let iv = e.target.value; // target value

        // limit the character input of the text field to only numbers, commas, decimal points, or blanks
        if (iv.match(/^[0-9.,$]+$/) || iv === "" || iv === "$") {
            var atEnd = iv === "" || iv === "$"
            var cleanIV = iv.replace(/,/g, "").replace(/\$/g, "").replace(/\./g, "")

            var fv = "0"

            if (iv !== "") {
                fv = parseFloat(cleanIV)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }

            // iv = validateInput.number(cleanIV);

            if (atEnd) {
                fv = ""
            }

            e.target.value = "$" + fv
        } else {
            e.target.value = "$0.00"
        }
    }

    const onSubmit = formData => {
        setSubmitted(true);

        if (props?.external === true) {
            formData['external'] = true;
        }

        // axios.defaults.headers.common['Authorization'] = "Bearer " + window.localStorage.getItem("token");
        axios.post(process.env.REACT_APP_LIMA + `/lima/api/payoff-request`, encodeJson(formData)
        ).then((data) => {
                setSubmitted(false);
                setSuccess(true);
            }
        ).catch(error => {
            setSubmitted(false);
            setSuccess(false);
        });
    }

    let tabIndex = 0
    // console.log(errors);

    // If API submission returns 200, redirect to thank you, otherwise show form
    // If API submission returns 200, redirect to thank you, otherwise show form
    if (success === true) {
        return <Redirect
            to={{
                pathname: '/thank-you/form',
                state: {
                    external: props?.external === true,
                    message: "Thank you! Please allow 3 business days to generate and approve the Payoff Letter. We will reach out to the email provided once complete."
                }
            }}
        />
    } else
        return (
            <div className="form loc-borrower form-payoff-request" id="form">
                <section className="section">
                    <div>
                        <p>Please allow up to <strong>two (2) business days</strong> from the date of submission for Payoff Requests to be completed.
                        <ul className='list'>
                            <li>A <strong>$10.00 fee</strong> is assessed for <strong>each payoff letter</strong> issued.</li>
                            <li>If <strong>more than one payoff request</strong> is submitted within a <strong>30-day period</strong>, a <strong>$30.00 fee</strong> will apply for each additional request.</li>
                            <li>A <strong>$100 fee</strong> is assessed for <strong>rush requests</strong>.</li>
                            <li>If you are requesting a Partial Payoff, additional fees may apply per the Note.</li>
                            <li>All fields must be completed before the form can be submitted.</li>
                        </ul>
                        </p>
                        <p>Lima One Capital reserves the right to <strong>decline or delay payoff requests</strong> for <strong>delinquent</strong> accounts.</p>
                        <p>&ldquo;Good Through&rdquo; Date:
                        <ul className='list'>
                            <li>A) Definition &ndash; The &ldquo;Good Through&rdquo; means the date through which the payoff amount stated in this letter remains accurate. If payment is not received in full by this date, additional interest, fees, or charges may accrue, and a revised payoff amount will be required.</li>
                            <li>B) Note &ndash; Insufficient payoff funds may result in a shortage which will delay lien release. To help prevent shortages, consider requesting a &ldquo;Good Through&rdquo; date beyond your estimated payoff date.</li>
                            <li>C) Disclaimer &ndash; The &ldquo;Good Through&rdquo; date requested cannot be more than 30 days from the date of the payoff request.</li>
                        </ul>
                        </p>
                        <p>If any of the following apply, please contact us for assistance:
                        <ul className='list'>
                            <li>Call (864) 210-3478.<ul>
                                    <li>Requesting a Payoff Statement for a severely delinquent account.</li>
                                </ul>
                            </li>
                            <li>Call (844) 871-0350.<ul>
                                    <li>Rush Payoff Request (additional fees apply)</li>
                                    <li>The requested &ldquo;Good Through&rdquo; date is greater than 30 days from the date the payoff request is made.</li>
                                </ul>
                            </li>
                        </ul>
                        </p>
                        <hr/>
                    </div>
                </section>

                <form className={`form-body ${errors.length > 0 ? 'form-error' : ''}`}
                      onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-payoff-request">

                        <div className="row input-field-group">
                            <div className="column">
                                <InputText ref={register({required: true})} type={'text'} label={'Loan Number*'}
                                           name={'loan_number'} errors={errors}/>
                            </div>

                            <div className="column">
                                <InputText ref={register({required: true})} type={'text'} label={[
                                    <div style={{height: '1.2em', bottom: '1em'}}>
                                        Property Address*
                                        <br/>
                                        <small style={{ whiteSpace: "nowrap" }}>(or "ALL" if paying off multi-property loan)</small>
                                    </div>
                                ]} name={'property_address'} errors={errors}/>
                            </div>

                            <div className="column">
                                <InputDate ref={register({required: true})} label={'Good through date? (see above)*'}
                                           name={'good_through_date'} errors={errors}/>
                            </div>
                            <div className="column">
                                <InputText ref={register({required: true})} type={'email'}
                                           label={'Payoff recipient email?*'} name={'email'} errors={errors}/>
                            </div>
                        </div>

                        <div className="row input-field-group grow-2">
                            <div className="column">
                                <InputText ref={register({required: false})} type={'email'} label={'Optional Email'}
                                           name={'optional_email'} errors={errors}/>
                            </div>

                            <div className="column">
                                <InputSelect ref={register({required: true})} label={'Sale or Refinance*'}
                                             name={'sale_or_refinance'} errors={errors} config={[
                                    {
                                        name: 'Sell',
                                        value: 'Sell'
                                    },
                                    {
                                        name: 'Refinance',
                                        value: 'Refinance'
                                    }
                                ]}/>
                            </div>

                            <div className="column">
                                <InputText ref={register({required: watchSellOrFinance === 'Sell'})}
                                           onChange={inputCurrency} type={'text'}
                                           label={`If sale, then what is the estimated sales price?${watchSellOrFinance === 'Sell' ? '*' : ''}`}
                                           name={'if_sale_then_what_is_the_estimated_sales_price'} errors={errors}/>
                            </div>

                            <div className="column">
                                <InputText ref={register({required: watchSellOrFinance === 'Refinance'})} type={'text'}
                                           label={`If refinance, name of lender and agent contact${watchSellOrFinance === 'Refinance' ? '*' : ''}:`}
                                           name={'if_refinance_name_of_lender_and_agent_contact'} errors={errors}/>
                            </div>

                            <div className="column">
                                <InputText ref={register({required: true})} type={'text'}
                                           label={'Updated borrower mailing address (City, State, Zip)*'}
                                           name={'updated_borrower_mailing_address'} errors={errors}/>
                            </div>

                        </div>

                        <div className="row input-field-group">
                            <div className="column">
                                <br/>
                                <ButtonSubmit readOnly={submitted}
                                              disabledIf={window.localStorage.getItem("employeeToken")}/>
                                {success === false ? "An error ocurred during submission.  Please try again later." : ""}
                            </div>
                        </div>

                    </div>
                </form>
            </div>
        )
}

export default withRouter(PayoffRequest)
